export class IInactiveSubInviteFormValues {
    subs: InactiveSubInviteEntity[];
}

export class InactiveSubInviteEntity {
    constructor(data: any) {
        this.subId = data.subId;
        this.subName = data.subName;
        this.subEmail = data.subEmail;
    }

    subId: number;
    subName: string;
    subEmail: string;
}

export type InactiveSubInviteFormActions = undefined | "saveAndRelease";
